export const RESOURCE_DATA_ATTRIBUTE = "data-resource";

export type GqlResourceIdentifier = {
	__typename: string;
	id: string;
};

export const getResourceDataAttribute = (resource: GqlResourceIdentifier): string => (
	resource.__typename + ":" + resource.id
);

export const resourceProps = (resource: GqlResourceIdentifier): Record<`data-${string}`, unknown> => ({
	[RESOURCE_DATA_ATTRIBUTE]: getResourceDataAttribute(resource),
});

export const resourceSelector = (resource: GqlResourceIdentifier): string => (
	"[" + RESOURCE_DATA_ATTRIBUTE + "=\"" + getResourceDataAttribute(resource) + "\"]"
);

export const scrollResourceIntoView = (resource: GqlResourceIdentifier, timeout = 100): void => {
	setTimeout(() => {
		const element = document.querySelector(resourceSelector(resource));
		element?.scrollIntoView({ block: "start", behavior: "smooth" });
	}, timeout);
};
